var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("owa-force-update-on-mounted", [
    _c(
      "header",
      {
        staticClass: "app-header",
        style: _vm.componentStyle,
        attrs: { id: "header" },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "nav-products nav-products-full display-none tablet:display-block",
          },
          [_c("page-header-products")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nav-app padding-y-md", attrs: { id: "nav-app" } },
          [
            _c(
              "div",
              {
                staticClass:
                  "container display-flex flex-content-between flex-nowrap",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "display-flex",
                    staticStyle: { gap: "var(--wa-space-2xs)" },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "flat swap-icons header-toggle-nav tablet:display-none",
                        attrs: {
                          "aria-label": "Open Main Menu",
                          "data-balloon-pos": "right",
                          "data-drawer": "open app-drawer",
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "initial-icon",
                          attrs: { icon: _vm.$v7.regular.faBars, size: "xl" },
                        }),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticClass: "hover-icon",
                          attrs: {
                            icon: _vm.$v7.solid.faHamburger,
                            size: "xl",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "header-nav display-none tablet:display-flex flex-items-center tablet:flex-items-stretch",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "wrap-links display-flex flex-items-center",
                            staticStyle: { gap: "var(--spacing-md)" },
                          },
                          [
                            _vm.$account
                              ? _c(
                                  "site-link",
                                  {
                                    class: _vm.mainLink(_vm.routes.kits),
                                    attrs: { to: _vm.routes.kits.location },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.$posthog.capture(
                                          "main_navigation_link_click",
                                          { destination: "kits" }
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "display-none laptop:display-inline",
                                      },
                                      [_vm._v("Your ")]
                                    ),
                                    _vm._v("Kits\n              "),
                                  ]
                                )
                              : _c(
                                  "site-link",
                                  {
                                    class: _vm.mainLink(_vm.routes.start),
                                    attrs: { to: _vm.routes.start.location },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.$posthog.capture(
                                          "main_navigation_link_click",
                                          { destination: "start" }
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Start\n              "
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.mainLink(_vm.routes.search),
                                attrs: {
                                  to: _vm.routes.search.location,
                                  title: "Search icons",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      { destination: "icon_search" }
                                    )
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: _vm.$v7.solid.faMagnifyingGlass,
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("Search Icons"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.mainLink(_vm.routes.icons),
                                attrs: { to: _vm.routes.icons.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      { destination: "icons" }
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Icons\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.mainLink(_vm.routes.docs),
                                attrs: { to: _vm.routes.docs.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      { destination: "docs" }
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n                Docs\n              ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.mainLink(_vm.routes.plans),
                                attrs: { to: _vm.routes.plans.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      { destination: "plans" }
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Plans\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.mainLink(_vm.routes.support),
                                attrs: { to: _vm.routes.support.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      { destination: "support" }
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Support\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "site-link",
                  {
                    staticClass: "button flat tablet:display-none",
                    attrs: {
                      to: { name: "home" },
                      "aria-label": "Font Awesome",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture(
                          "main_navigation_link_click",
                          { destination: "home" }
                        )
                      },
                    },
                  },
                  [_c("owa-logo-flag", { attrs: { "logo-size": "2xl" } })],
                  1
                ),
                _vm._v(" "),
                _vm.$account
                  ? _c(
                      "site-link",
                      {
                        class: [
                          "button flat",
                          { active: _vm.routes.account.active },
                        ],
                        attrs: {
                          to: _vm.routes.account.location,
                          "aria-label": "Your Account",
                          "data-balloon-pos": "left",
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "main_navigation_link_click",
                              { destination: "account" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v7.regular.faCircleUser,
                            size: "xl",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Your Account"),
                        ]),
                      ],
                      1
                    )
                  : _c(
                      "site-link",
                      {
                        class: [
                          "button flat swap-icons",
                          { active: _vm.routes.signIn.active },
                        ],
                        attrs: {
                          to: _vm.routes.signIn.location,
                          "aria-label": "Sign In",
                          "data-balloon-pos": "left",
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "main_navigation_link_click",
                              { destination: "sign_in" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "initial-icon",
                          attrs: {
                            icon: _vm.$v7.regular.faRightToBracket,
                            size: "xl",
                          },
                        }),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticClass: "hover-icon",
                          attrs: {
                            icon: _vm.$v7.regular.faPersonToPortal,
                            size: "xl",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Sign In"),
                        ]),
                      ],
                      1
                    ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c("page-header-drawer"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }